import './App.css' 

function About(){
    return(
        <div className="abt">
         <div className="bg-light">
  <div className="container py-5">
    <div className="row h-100 align-items-center py-5">
      <div className="col-lg-6">
        <h1 className="display-4">About us </h1>
        <p className="lead text-muted mb-0">DDAI is a cutting-edge technology company that is dedicated to improving the way people live and work. Our goal is to harness the power of artificial intelligence and blockchain technology to create a more secure and efficient future.

Founded by a team of experts in the fields of AI and blockchain, DDai is leading the way in the development of decentralized autonomous organizations (DAOs). These organizations are run by a decentralized network of users, rather than by a central authority, which allows for greater transparency, security, and efficiency.

At DDai, we believe that DAOs have the potential to revolutionize the way we do business, and we are committed to building the tools and infrastructure necessary to make this a reality. Our team is made up of experienced developers, researchers, and visionaries who are passionate about the potential of blockchain technology.

One of our flagship products is the DDai Platform, a decentralized platform for creating and managing DAOs. The DDai Platform provides a user-friendly interface for users to create, manage, and participate in DAOs, as well as a suite of powerful tools for developers to build and integrate with the platform.</p>
        
      </div>
      <div className="col-lg-6 d-none d-lg-block"><img src="https://bootstrapious.com/i/snippets/sn-about/illus.png" alt="" className="img-fluid"/></div>
    </div>
  </div>
</div>

<div className="bg-white py-5">
  <div className="container py-5">
    <div className="row align-items-center mb-5">
      <div className="col-lg-6 order-2 order-lg-1"><i className="fa fa-bar-chart fa-2x mb-3 text-primary"></i>
        <h2 className="font-weight-light">CEO, SAMUEL BAHIRU</h2>
        <p className="font-italic text-muted mb-4">As the CEO of DDAI, he is driving the company forward in its mission to revolutionize the way people live and work using these cutting-edge technologies.

With a background in computer science and a deep understanding of the potential of AI and blockchain, Samuel Bahiru is well-equipped to lead DDai to new heights. Under his leadership, the company has grown rapidly, establishing itself as a leader in the development of decentralized autonomous organizations (DAOs).

Samuel Bahiru is a passionate advocate for the potential of DAOs to create a more secure, efficient, and transparent future. He is dedicated to building the tools and infrastructure necessary to make this a reality, and his work has been recognized by experts in the field.</p><a href="#" className="btn btn-light px-5 rounded-pill shadow-sm">Learn More</a>
      </div>
      <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2"><img src="https://bootstrapious.com/i/snippets/sn-about/img-1.jpg" alt="" className="img-fluid mb-4 mb-lg-0"/></div>
    </div>
    <div className="row align-items-center">
      <div className="col-lg-5 px-5 mx-auto"><img src="https://bootstrapious.com/i/snippets/sn-about/img-2.jpg" alt="" className="img-fluid mb-4 mb-lg-0"/></div>
      <div className="col-lg-6"><i className="fa fa-leaf fa-2x mb-3 text-primary"></i>
        <h2 className="font-weight-light">Our services</h2>
        <p className="font-italic text-muted mb-4">DDai Platform: DDai's flagship product is a decentralized platform for creating and managing decentralized autonomous organizations (DAOs). The DDai Platform provides a user-friendly interface for users to create, manage, and participate in DAOs, as well as a suite of powerful tools for developers to build and integrate with the platform.

AI Development: DDai's team of experts in AI provides a range of services to help businesses and individuals harness the power of artificial intelligence. These services include AI consulting, AI strategy development, and custom AI development services.

Blockchain Development: DDai's team of blockchain experts provides a range of services to help businesses and individuals develop decentralized solutions using blockchain technology. These services include blockchain consulting, blockchain strategy development, and custom blockchain development services.

DAO Development: DDai's team of experts in DAOs provides a range of services to help businesses and individuals develop and implement decentralized autonomous organizations. These services include DAO consulting, DAO strategy development, and custom DAO development services.

Overall, DDai's goal is to provide a range of services that help businesses and individuals harness the power of AI and blockchain to transform the way they live and work. Whether you are looking to build a new product, implement a new technology, or simply learn more about the potential of AI and blockchain, DDai is here to help.</p><a href="#" className="btn btn-light px-5 rounded-pill shadow-sm">Learn More</a>
      </div>
    </div>
  </div>
</div>

<div className="bg-light py-4">
  <div className="container py-5">
    <div className="row mb-4">
      <div className="col-lg-5">
        <h2 className="display-4 font-weight-light">Our team</h2>
        <p className="font-italic text-muted">we have developer, tester, security assurance ...</p>
      </div>
    </div>

    <div className="row text-center">
      
      <div className="col-xl-3 col-sm-6 mb-5">
        <div className="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-4.png" alt="" width="100" className="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"/>
          <h5 className="mb-0">Manuella Nevoresky</h5><span className="small text-uppercase text-muted">Business Analyst</span>
          <ul className="social mb-0 list-inline mt-3">
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-facebook-f"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-twitter"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-instagram"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>
       

  
      <div className="col-xl-3 col-sm-6 mb-5">
        <div className="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-3.png" alt="" width="100" className="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"/>
          <h5 className="mb-0">Samuel Bahiru</h5><span className="small text-uppercase text-muted">CEO - Founder</span>
          <ul className="social mb-0 list-inline mt-3">
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-facebook-f"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-twitter"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-instagram"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-linkedin"></i></a></li>
          </ul>
        
      </div>
      </div>
       

       
      <div className="col-xl-3 col-sm-6 mb-1">
        <div className="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-2.png" alt="" width="100" className="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"/>
          <h5 className="mb-0">Tom Sunderland</h5><span className="small text-uppercase text-muted">Developer</span>
          <ul className="social mb-0 list-inline mt-3">
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-facebook-f"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-twitter"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-instagram"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-linkedin"></i></a></li>
          </ul>
      
      </div>
      </div>
       

       
      <div className="col-xl-3 col-sm-6 mb-2">
        <div className="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-1.png" alt="" width="100" className="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"/>
          <h5 className="mb-0">John Tarly</h5><span className="small text-uppercase text-muted">Quality Assurnace</span>
          <ul className="social mb-0 list-inline mt-3">
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-facebook-f"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-twitter"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-instagram"></i></a></li>
            <li className="list-inline-item"><a href="#" className="social-link"><i className="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>
       </div>

    </div>
  </div>
</div>
       
    )
}

export default About